import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { StatementDefinition } from '@reporting/rp-types/definition';

export class FinTreeCopyFormAdapter extends FormAdapter {

	constructor(
		private statement: StatementDefinition,
		private year: number = null
	) { super() }

	getColumns() {
		return [
			{width: 120},
			{width: null},
		];
	}

	async getControls() {
		const yearsFrom = await rp.ms('analytics').get<number[]>(`statementYears/${this.statement.id_statement}/nonempty`);
		const yearsTo = await rp.ms('analytics').get<number[]>(`statementYears/${this.statement.id_statement}/empty`);
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('From year'), for: 'yearFrom'},
			{row: 0, col: 1, type: FormControlType.List, key: 'yearFrom', required: true, value: this.year, content: {
				sourceData: yearsFrom.map(year => ({k: year, v: year})),
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('To year'), for: 'yearTo'},
			{row: 1, col: 1, type: FormControlType.List, key: 'yearTo', required: true, content: {
				sourceData: yearsTo.map(year => ({k: year, v: year})),
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Replace definition'), for: 'replace'},
			{row: 2, col: 1, type: FormControlType.Checkbox, key: 'replace', value: true},
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [{ key: "save", text: msg("Copy"), color: ColorTypes.Yellow }, "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		await rp.ms('definition').post('statementRows/copy', {
			idStatement: this.statement.id_statement,
			yearFrom: formValues.yearFrom,
			yearTo: formValues.yearTo,
			replace: formValues.replace
		});
		return true;
	}

};
